import { createFileRoute } from "@tanstack/react-router"
import { AccountPage } from "@/components/AccountPage"

// Auth gating lives in the `_authenticated` parent component.
export const Route = createFileRoute(`/_authenticated/account`)({
  component: Account,
  ssr: false,
})

function Account() {
  return <AccountPage />
}
